import React from "react";

import { useTranslation } from "react-i18next";

import { ScoreValue } from "~/sdks/LocalContent/components/ScoreValue";
import { ColorIcon } from "~/sdks/LocalContent/components/ColorIcon";
import { ScoreIcon } from "~/components/ScoreIcon";

import type { RootProps } from "../../types";
import { useRootElement } from "../../context";

import * as styles from "./styles";

export type HeaderProps = {
  scoreKey: RootProps["activeScore"];
  scoreValue?: number;
};

export function Header({ scoreKey, scoreValue }: HeaderProps) {
  const { t } = useTranslation(["common"]);
  const { activeScoreData } = useRootElement();

  if (scoreKey === null) {
    return null;
  }

  return (
    <div
      className={styles.container}
      data-testid="sidebar-score-details-header"
    >
      <span className={styles.title}>
        <ColorIcon
          element={<ScoreIcon score={scoreKey} />}
          backgroundColor={activeScoreData?.categoryOptions?.colors?.background}
          fillColor={activeScoreData?.categoryOptions?.colors?.fill}
        />
        <span className={styles.text}>
          {t(`common:scores.${scoreKey}.title`)}
        </span>
      </span>
      <ScoreValue scoreKey={scoreKey} value={scoreValue} />
    </div>
  );
}
